var $ = require('jquery')
$(function () {
  const chartElement = document.getElementById('js-contracted-part-type-distribution-chart')

  if (chartElement === null) {
    return
  }

  const { labels, values } = JSON.parse(chartElement.dataset.chart)

  new Chart(chartElement, {
    type: 'doughnut',
    data: {
      labels,
      datasets: [{
        label: '件数',
        data: values,
        backgroundColor: (context) => {
          const currentIndex = context.dataIndex
          const datasetLength = context.dataset.data.length || 1
          const magnification = 1 / datasetLength
          const alpha = 1 - (magnification * (currentIndex - 1))

          if (currentIndex === 0) {
            return '#f6ce44' // 1番件数の多いものはオレンジ色にする
          }
          return `rgb(46, 176, 199, ${alpha >= 1 ? 1 : alpha})`
        }
      }]
    },
    options: {
      legend: {
        position: 'left',
        align: 'start'
      }
    }
  })
})
